var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('page-header',{attrs:{"title":"Новый лимит"}}),_c('limit-form',{attrs:{"model":_vm.limit}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }